import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TooltipLoader } from '../../global/TooltipLoader';
import { vettedDescription } from '../messages/pdpDistinctionsMessages';
import styles from './PdpRespSidebarSellerInfoTitle.scss';

class PdpRespSidebarSellerInfoTitle extends React.Component {
    constructor() {
        super();

        this.state = {
            load: false,
            isVisible: false,
        };
    }

    render() {
        const { sellerCompany } = this.props;
        const { isVisible, load } = this.state;
        const mouseProps = {
            onMouseEnter: () => this.setState({ isVisible: !isVisible, load: true }),
            onMouseLeave: () => this.setState({ isVisible: !isVisible }),
        };

        return (
            <span {...mouseProps} className={styles.title}>
                {sellerCompany || (
                    <FormattedMessage
                        id="PdpRespSidebarSellerInfo.vettedTitle"
                        defaultMessage="Vetted Professional Seller"
                    />
                )}
                <TooltipLoader load={load} isVisible={isVisible} direction="bottom" align="right">
                    {vettedDescription}
                </TooltipLoader>
            </span>
        );
    }
}

PdpRespSidebarSellerInfoTitle.propTypes = {
    sellerCompany: PropTypes.string,
};

export { PdpRespSidebarSellerInfoTitle };
